import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Nav extends Component {
	render() {
		const { site_title, links } = this.props;

		const link_nodes = links.map(l => {
			return (
				<div className='link-container'>
					<Link key={l.href} to={l.href}>{l.title}</Link>
				</div>
			)
		})

		return (
			<nav className='nav'>
				<div className='nav-group'>
					<div className='link-container'>
						<Link to="/">
							<img
								src='/images/logo/cyberbutler-logo.png'
								className='logo logo-md'
							/>
							{site_title}
						</Link>
					</div>
				</div>
				<div className='nav-group'>
					{link_nodes}
				</div>
			</nav>
		)

	}
}

export default Nav;



// WEBPACK FOOTER //
// ./src/Nav.js